import React from 'react';
import Box from '@mui/material/Box';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Typography from '@mui/material/Typography';
import Voices from './admin/Voices';

const AdminPage: React.FC = () => {
  const [tab, setTab] = React.useState(0);
  const handleChange = (_: React.SyntheticEvent, v: number) => setTab(v);

  return (
    <Box sx={{ p: 3 }}>
      <Typography variant="h5" sx={{ mb: 2 }}>Admin</Typography>
      <Tabs value={tab} onChange={handleChange} variant="scrollable" allowScrollButtonsMobile>
        <Tab label="Voices" />
        <Tab label="Tab 2" />
        <Tab label="Tab 3" />
        <Tab label="Tab 4" />
        <Tab label="Tab 5" />
        <Tab label="Tab 6" />
      </Tabs>

      <Box sx={{ mt: 2 }}>
        {tab === 0 && <Voices />}
        {tab === 1 && <Typography variant="body1">Tab 2 content</Typography>}
        {tab === 2 && <Typography variant="body1">Tab 3 content</Typography>}
        {tab === 3 && <Typography variant="body1">Tab 4 content</Typography>}
        {tab === 4 && <Typography variant="body1">Tab 5 content</Typography>}
        {tab === 5 && <Typography variant="body1">Tab 6 content</Typography>}
      </Box>
    </Box>
  );
};

export default AdminPage;
